'use strict';

"use strict";
const closePointEps = 1e-4;
const curveEps = 1e-4;

exports.closePointEps = closePointEps;
exports.curveEps = curveEps;
//# sourceMappingURL=const.js.map
